module.exports = __webpack_public_path__ + "static/about2-f9c83872f1e7b4416b474cb1c2b708cf.png";